import axios, { AxiosResponse } from 'axios';
import { Formik } from 'formik';
import React, { FC, useState } from 'react';
import { COMPANY_DEBIT_FORM, COMPANY_DEBIT_FORM_PDF } from '../../constants/paths/api';
import { downloadPdf } from '../../helpers/pdfHelpers/downloadApi';
import { ICompanyDebitFormDTO } from '../../interfaces/forms/companyDebitForm';
import { Column, Columns } from '../base/grid';
import { RawLoader } from '../loading/loading';
import SuccessOrFailure from '../successOrFailure';
import { CompanyDebitFormSchema, stepInfoInitialValues } from './companyDebitForm.schema';
import * as StyledCompanyDebitForm from './companyDebitForm.styles';
import CompanyDebitFormForm from './companyDebitFormForm';

interface Props {}

const CompanyDebitForm: FC<Props> = () => {
	const [errorInRequest, setErrorInRequest]: [boolean, any] = useState(null);
	const [errorMessage, setErrorMessage] = useState('');
	const [isLoading, setIsLoading]: [boolean, any] = useState(false);
	// const { t } = useTranslation('common');
	const [pdf, setPdf] = useState(null);

	const submitDebitRequest = async values => {
		values.identificationNumber = values.identificationNumber.trim();
		setIsLoading(true);
		try {
			const { data }: AxiosResponse<ICompanyDebitFormDTO> = await axios.post(`${COMPANY_DEBIT_FORM}`, values);
			setErrorInRequest(!data.valid);
			setErrorMessage(data.valid ? '' : data.invalidMessage);

			if (data.valid) {
				axios({
					url: `${COMPANY_DEBIT_FORM_PDF}${data.orderNumber}?pdfPassword=${data.pdfPassword}&email=${values.email}`,
					method: 'GET',
					responseType: 'blob',
				}).then(res => {
					downloadPdf(res.data, `beidni-${data.orderNumber}`);
					setPdf(res.data);
				});
			}
		} catch (error: any) {
			setErrorInRequest(true);
			setErrorMessage(error.response?.data?.details || error.response?.data?.message || error.message);
		} finally {
			setIsLoading(false);
		}
	};

	const downloadFile = () => {
		downloadPdf(pdf, `beidni`);
	};

	if (isLoading) return <RawLoader />;

	return (
		<StyledCompanyDebitForm.Wrapper>
			<Columns>
				{errorInRequest === null && (
					<Column>
						<Formik
							initialValues={stepInfoInitialValues}
							enableReinitialize
							validationSchema={CompanyDebitFormSchema}
							onSubmit={submitDebitRequest}>
							{({ values, setFieldTouched, setFieldValue, isValid, isSubmitting, isValidating, errors, touched }) => (
								<CompanyDebitFormForm
									values={values}
									errors={errors}
									setFieldTouched={setFieldTouched}
									setFieldValue={setFieldValue}
									isSubmitting={isSubmitting}
									isValidating={isValidating}
									isValid={isValid}
									touched={touched}
								/>
							)}
						</Formik>
					</Column>
				)}
				<SuccessOrFailure
					hasSubmitted={errorInRequest !== null}
					success={!errorInRequest}
					addLink
					downloadFileFunction={downloadFile}
					errorMessage={errorMessage}
				/>
			</Columns>
		</StyledCompanyDebitForm.Wrapper>
	);
};

export default CompanyDebitForm;
